import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SearchStudent } from "../../_models/search-student/search-student.model";
import { StudentSearchParameters } from "./models/student-search-paramters";

@Component({
    selector: 'student-search-modal',
    templateUrl: 'student-search-modal.component.html',
    styleUrls: ['student-search-modal.component.css'],
    standalone: false
})
export class StudentSearchModalComponent {
  public searchData: StudentSearchParameters;

  @Output() addStudent = new EventEmitter<SearchStudent>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.searchData = data as StudentSearchParameters;
  }

  public replaceStudent(student: SearchStudent): void {
    this.addStudent.emit(student);
  }
}
